export default "__VITE_ASSET__DZkVDpgn__"